var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWrench = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#E6F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 19.9998C36.6685 21.4965 36.2967 22.97 35.5852 24.2869C34.8737 25.6037 33.8451 26.7224 32.5923 27.5415C31.3396 28.3606 29.9023 28.8543 28.4107 28.978C26.919 29.1017 25.4201 28.8514 24.0495 28.2498L17.542 35.7773C17.527 35.7948 17.5095 35.8135 17.4933 35.8298C16.743 36.58 15.7255 37.0015 14.6645 37.0015C13.6035 37.0015 12.586 36.58 11.8358 35.8298C11.0855 35.0795 10.6641 34.062 10.6641 33.001C10.6641 31.94 11.0855 30.9225 11.8358 30.1723C11.8533 30.156 11.8708 30.1385 11.8895 30.1235L19.417 23.6173C18.7426 22.0745 18.514 20.3736 18.7572 18.7076C19.0004 17.0415 19.7056 15.477 20.7929 14.1914C21.8801 12.9058 23.3059 11.9506 24.9084 11.4342C26.511 10.9178 28.2262 10.8608 29.8595 11.2698C30.0279 11.312 30.1824 11.3972 30.3078 11.5173C30.4332 11.6373 30.5252 11.7879 30.5748 11.9542C30.6243 12.1206 30.6297 12.2969 30.5905 12.466C30.5512 12.6351 30.4686 12.791 30.3508 12.9185L25.667 17.9998L26.3745 21.2935L29.667 21.9998L34.7483 17.3098C34.8757 17.1919 35.0317 17.1093 35.2008 17.0701C35.3698 17.0308 35.5462 17.0362 35.7126 17.0858C35.8789 17.1353 36.0295 17.2273 36.1495 17.3527C36.2695 17.4781 36.3548 17.6326 36.397 17.801C36.5765 18.5201 36.6671 19.2586 36.667 19.9998Z",
    fill: "#0699A3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWrench, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wrench.6089d8fc.svg";
export { ForwardRef as ReactComponent };